import React from 'react'
import { useTranslation } from 'react-i18next'
import Page from './Page'
import Toolbar from 'app/components/Toolbar'

const ErrorPage = ({ error }) => {
  const { t } = useTranslation()

  let message

  switch (error.status) {
    case 'NOT_FOUND':
      message = 'invalidShare'
      break
    case 'FAILED_PRECONDITION':
      message = 'disabledShare'
      break
    case 'RESOURCE_EXHAUSTED':
      message = 'usedShare'
      break
    default:
      message = 'unknown'
      break
  }

  return (
    <Page title={t(`errorPage.${message}.title`)} toolbar={<Toolbar />}>
      <Page.Message>{t(`errorPage.${message}.message`)}</Page.Message>
    </Page>
  )
}

export default ErrorPage
